document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll(".number");

  // Force comma formatting manually
  const formatWithCommas = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  function animateCounter(el) {
    const target = Number(el.dataset.target);
    if (!Number.isFinite(target)) return;

    const duration = 2000;
    const startTime = performance.now();

    const easeOutQuad = (t) => t * (2 - t);

    function tick(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const value = Math.floor(easeOutQuad(progress) * target);
      el.textContent = formatWithCommas(value);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = formatWithCommas(target);
      }
    }

    requestAnimationFrame(tick);
  }

  // Animate when visible
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(el => observer.observe(el));
});